var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google__G__Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M13.1716 7.17151C13.1716 6.73639 13.1363 6.29891 13.061 5.87085H7.02344V8.33575H10.4809C10.3374 9.13072 9.87641 9.83397 9.20139 10.2808V11.8802H11.2641C12.4754 10.7654 13.1716 9.11896 13.1716 7.17151Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M7.02329 13.4254C8.74966 13.4254 10.2055 12.8585 11.2663 11.8801L9.20359 10.2808C8.6297 10.6712 7.88882 10.8923 7.02564 10.8923C5.35572 10.8923 3.93981 9.76566 3.43178 8.25098H1.30322V9.89973C2.38985 12.0612 4.60308 13.4254 7.02329 13.4254Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M3.42967 8.25103C3.16154 7.45605 3.16154 6.59522 3.42967 5.80024V4.15149H1.30346C0.395591 5.96018 0.395591 8.09109 1.30346 9.89978L3.42967 8.25103Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M7.02329 3.15658C7.93586 3.14247 8.81786 3.48586 9.47877 4.1162L11.3063 2.28869C10.1491 1.20207 8.61324 0.604662 7.02329 0.623478C4.60308 0.623478 2.38985 1.98764 1.30322 4.15148L3.42943 5.80023C3.93511 4.28319 5.35337 3.15658 7.02329 3.15658Z",
    fill: "#EA4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e1df0d33a590d60650d27c2bf7b31b1e.svg";
export { ForwardRef as ReactComponent };